export enum ICarrierNumberType {
  MC = 'MC',
  DOT = 'DOT',
}
